import styled from '@emotion/styled';
import Dialog from 'lib/components/Dialog';

const PromptControlsWrapper = styled(Dialog.Content)({
  marginTop: -8
});

export default PromptControlsWrapper;
